<template>
  <section class="alliances">
    <div v-if="alliances">
      <div class="produtos-wrapper">
        <AllianceItem />
      </div>
    </div>
    <LoadingBox v-else-if="!alliances" />
  </section>
</template>

<script>
import AllianceItem from '@/components/AllianceItem.vue';
import LoadingBox from '@/components/LoadingBox.vue';
import { api } from '@/services/services';
import { mapState } from 'vuex';

export default {
  components: {
    AllianceItem,
    LoadingBox,
  },
  computed: {
    ...mapState(['usuario', 'login', 'alliances']),
  },
  methods: {
    async getAlliances() {
      try {
        const response = await api.get('alliances/lista');
        this.alliances = response.data;
      } catch (error) {
        console.error('Erro ao buscar as imagens:', error);
      }
    },
  },
  watch: {
    login() {
      this.getAlliances();
    },
  },
  created() {
    if (this.login) {
      this.$store.dispatch('fetchAlliances');
    }
    document.title = 'Alliances';
  },
};
</script>

<style scoped>
.produto-wrapper {
  margin-bottom: 40px;
}

.vendedor span {
  color: #e80;
}

h2 {
  margin-bottom: 20px;
}
</style>
